import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface ISelected extends Record<string, string | undefined> {
  guid: string;
  value: string;
  id: string;
  stateGuid?: string;
  stateTitle?: string;
  state_id?: string;
}

export interface ISerachingLocation {
  locational: ISelected[];
}

const initialState: ISerachingLocation = {
  locational: [],
};

export const searchingLocationSlice = createSlice({
  name: 'searchingLocation',
  initialState,
  reducers: {
    addAddress: (state, action: PayloadAction<ISelected[]>) => {
      state.locational = [...state.locational, ...action.payload];
    },
    addStates: (state, action: PayloadAction<ISelected[]>) => {
      state.locational = [...state.locational, ...action.payload];
    },

    removeState: (state, action: PayloadAction<ISelected[]>) => {
      state.locational = [...action.payload];
    },
    replaceAddress: (state, action: PayloadAction<ISelected[]>) => {
      state.locational = action.payload;
    },
    clearAddress: state => {
      state.locational = [];
    },
  },
});

export const {
  addAddress,
  replaceAddress,
  clearAddress,
  addStates,
  removeState,
} = searchingLocationSlice.actions;

export default searchingLocationSlice.reducer;
